export default __webpack_public_path__ + "static/media/shoppingBagVector.60e4d04c.svg";